// import store from "@/store/index";
import axios from "axios";
import REF_MSO_AGC from "@/data/REF_MSO_AGC.json";
import REF_MSO_ORG from "@/data/REF_MSO_ORG.json";
const LOCAL_REF_MSO_AGC = structuredClone(REF_MSO_AGC);
const LOCAL_REF_MSO_ORG = structuredClone(REF_MSO_ORG);

function getProvince() {
  return new Promise((resolve, reject) => {
    const config = {
      url: `${process.env.VUE_APP_BASE_API}refadms/`,
      method: "GET",
    };
    axios(config)
      .then((response) => {
        let data = response.data.sort((a, b) =>
          a.province_name > b.province_name ? 1 : -1
        );
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function getOrganize() {
  return LOCAL_REF_MSO_AGC.sort(
    (a, b) => a.AGC_NAME > b.AGC_NAME ? 1 : -1
  );
}
function getSubOrganizeByOrganize(val) {
  return LOCAL_REF_MSO_ORG
    .filter(
      (name) => name.AGC_NAME === val.AGC_NAME
    )
    .sort(
      (a, b) => a.ORG_NAME > b.ORG_NAME ? 1 : -1
    );
}
function getAllSubOrganize() {
  return LOCAL_REF_MSO_ORG.sort(
    (a, b) => a.ORG_NAME > b.ORG_NAME ? 1 : -1
  );
}
export {
  getProvince,
  getOrganize,
  getSubOrganizeByOrganize,
  getAllSubOrganize,
};
